import { markRaw } from 'vue'
import CodeCell from '@/onenetwork/components/datatable/CodeCell.vue'
import TagCell from '@/onenetwork/components/datatable/TagCell.vue'
import TextCell from '@/onenetwork/components/datatable/TextCell.vue'
import NumberCell from '@/onenetwork/components/datatable/NumberCell.vue'
import MoneyCell from '@/onenetwork/components/datatable/MoneyCell.vue'
import DateTimeCell from '@/onenetwork/components/datatable/DateTimeCell.vue'

export const parseDataTable = (data: any) => {
  if( data && data.length > 0 ){
    return data.map((item: any) => {
      return {
        id: item.id,
        code: item.contract?.code,
        status: getStatus(item),
        type: getType(item),
        account: item.user,
        tax: item.user?.broker_profile?.tax_id,
        bankInfo: item.user,
        rate: item.commission_rate * 100,
        amount: item.commission_amount,
        created_at: item.updated_at,
        action_by: item.admin?.full_name,
      }
    })
  }
  return []
}

function getType(item: any){
  // console.log(item)
  switch (item.type){
    case "S": return [{type: 'info', label: "MG Bán"}]
    case "S_ROOT": return [{type: 'info', label: "GD MG Bán"}]
    case "S_SUP": return [{type: 'info', label: "Cấp trên TT MG Bán"}]
    case "B": return [{type: 'info', label: "MG Mua"}]
    case "B_ROOT": return [{type: 'info', label: "GD MG Mua"}]
    case "B_SUP": return [{type: 'info', label: "Cấp trên TT MG Mua"}]
    default: return [{type: 'warn', label: "Quỹ & Bộ Phận Hỗ Trợ"}]
  }
}

function getStatus(item: any){
  // console.log(item)
  switch (item.status){
    case 'waiting': return [{type: 'secondary', label: 'Đang quyết toán'}]
    case 'paid': return [{type: 'success', label: 'Đã chi trả'}]
    default: return [{type: 'info', label: item.status}]
  }
}
